module.exports = __webpack_public_path__ + "static/img/reading.cf86e657.svg";